import { Component, Injectable } from '@angular/core';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { DatePipe, DecimalPipe } from '@angular/common';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { SWAlertService } from './swalert.service';
import { AuthService } from './auth.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})

export class TSFuntionService {

  constructor(
    private _http: HttpClient,
    private _DP: DatePipe,
    private _DCP: DecimalPipe,
    private _ActivatedRoute: ActivatedRoute,
    private _router: Router,
    private _swal: SWAlertService
  ) { }

  SiteName: string = "";
  SysProcess = {
    FileOversize: "OverSize",
    FileInvalidType: "InvalidType",
    Failed: "Failed",
    Success: "Success",
    SessionExpired: "SSEXP",
    Duplicate: "DUP"
  }
  SessionExpire() {
    this.UnBlockUI();
    let This = this;
    if (sessionStorage.getItem('SSC_SESSION_EXPIRED_HANDLING') === 'Y') {
      return;
    }

    sessionStorage.setItem('SSC_SESSION_EXPIRED_HANDLING', 'Y');
    this._swal.SwAlert.Error(this._swal.BoxMsg.Title_Session, "", function () {
      This._router.navigate(['/login']).then(function () {
        setTimeout(function () {
          sessionStorage.removeItem('SSC_SESSION_EXPIRED_HANDLING');
        }, 1000);
      });
    });
  }
  //#region UserAccount
  LoginKey = 'UserAcc';
  UserAcc: any = {};
  UserLogin() {
    const httpOptions_User = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    this._http.get<any>(this.SiteName + "api/_System/GetLoginStorage", httpOptions_User).subscribe(res => {
      if (res) {
        localStorage.removeItem(this.LoginKey);
        sessionStorage.setItem(this.LoginKey, JSON.stringify(res));
        this.CreateTimeInterval();
        if (res.nRole == 6 || res.nRole == 1) {//SVM 
          this._router.navigate(["/search"]);
        }
        else if (res.nRole == 5 && res.cROService == 'Y') {//RO Service 
          this._router.navigate(["/ro-service"]);
        }
        else {
          this._router.navigate(["/home"]);
        }
      }
    });
  }
  GetUserStorage() {
    localStorage.removeItem(this.LoginKey);
    return JSON.parse(sessionStorage.getItem(this.LoginKey));
  }
  RemoveUserStorage() {
    localStorage.removeItem(this.LoginKey);
    sessionStorage.removeItem(this.LoginKey);
  }
  //#endregion
  //#region BlockUI
  public divLoading = document.getElementById("divLoading");
  BlockUI() {
    this.divLoading.style.display = "block";
  }
  UnBlockUI() {
    this.divLoading.style.display = "none";
  }
  //#endregion

  //#region EnCrypt
  GetQuerySTR(_STR) {
    let Result: string = "";
    this._ActivatedRoute.queryParams.subscribe(params => {
      Result = (params[_STR] + "");
    });
    return Result;
  }
  async Encrypt(str) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let _Text = JSON.stringify({ str: str });
    let _EN_STR = await this._http.post("api/_System/Encrypt", _Text, { headers, responseType: 'text' }).toPromise();
    return _EN_STR;
  }
  async Decrypt(str) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let _Text = JSON.stringify({ str: str });
    let _DC_STR = await this._http.post("api/_System/Decrypt", _Text, { headers, responseType: 'text' }).toPromise();
    return _DC_STR;
  }
  //#endregion
  //#region Convert Data
  _ParseToDecimal(sVal) {
    let Data: any = null;
    if (sVal) {
      let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
      Data = this._DCP.transform(NoComma, "1.2-2");
    }
    else if (sVal == 0) {
      let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
      Data = this._DCP.transform(NoComma, "1.2-2");
    }
    return Data;
  }
  _ParseDateToFormat(dDate: Date, sFormat: string) {
    let _Format: string = "dd/MM/yyyy";
    if (sFormat) {
      _Format = sFormat;
    }
    return this._DP.transform(dDate, _Format);
  }
  _FormatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
  _ParseFloatToZero(sVal) {
    let Result: any = 0;
    if (sVal) {
      let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
      Result = parseFloat(NoComma);
    }
    return Result;
  }
  _ParseFloatToNull(sVal) {
    let Result: any = null;
    if (sVal) {
      let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
      Result = parseFloat(NoComma);
    }
    return Result;
  }
  ParseIntToZero(sVal) {
    let Result: number = 0;
    if (sVal) {
      let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
      Result = parseInt(NoComma);
    }
    return Result;
  }
  ParseIntToNull(sVal) {
    let Result = null;
    if (sVal) {
      let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
      Result = parseInt(NoComma);
    }
    return Result;
  }
  _ParseString(str) {
    var Result = "";
    if (str && str != "null") {
      Result = str.trim();
    }
    return Result;
  }
  _IsNullOrEmpty(str) {
    var Result = true;
    if (str && str != "null") {
      Result = false;
    }
    return Result;
  }
  _ParseDateToUTC(str): Date {
    var dDate: Date = null;
    if (str && str != "null") {
      let STR = str.substring(0, 10).split('-');
      let Year = this.ParseIntToZero(STR[0]);
      let Month = this.ParseIntToZero(STR[1]) - 1;
      let Day = this.ParseIntToZero(STR[2]);
      if (STR.length < 2) {
        STR = str.substring(0, 10).split('/');
        Year = this.ParseIntToZero(STR[2]);
        Month = this.ParseIntToZero(STR[1]) - 1;
        Day = this.ParseIntToZero(STR[0]);
      }
      if (STR.length > 2) {
        dDate = new Date(Date.UTC(Year, Month, Day));
      }
    }
    return dDate;
  }
  _ParseDateToNull(str): Date {
    var dDate: Date = null;
    if (str && str != "null") {
      let STR = str.substring(0, 10).split('/');
      if (STR.length > 2) {
        let Year = this.ParseIntToZero(STR[2]);
        let Month = this.ParseIntToZero(STR[1]) - 1;
        let Day = this.ParseIntToZero(STR[0]);
        dDate = new Date(Year, Month, Day);
      }
    }
    return dDate;
  }
  //#endregion

  OnFocus(CtrlID1, CtrlID2) {
    document.getElementById(CtrlID1).addEventListener("keydown", function (e) {
      if (e.which == 13) { //keyCode - ENTER : 13
        document.getElementById(CtrlID2).click();
        return false;
      }
      else if (e.which == 220) return false; //keyCode - BACKSLASH : 220
    })
  }

  async CheckPermission(ObjData) {
    let _this = this;
    var Chk = false;
    const httpOptions_ChkPermission = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }), params: new HttpParams()
        .set('sRequestID', ObjData.sRequestID)
        .set('nMenuID', ObjData.nMenuID)
    };
    Chk = await this._http.get<any>(this.SiteName + "api/_System/CheckPermission", httpOptions_ChkPermission).toPromise();
    let ua = this.GetUserStorage();
    if (ua != null) {
      if (Chk) {
        return Chk;
      } else {
        this._swal.SwAlert.Error(this._swal.BoxMsg.Title_Error, this._swal.BoxMsg.Desc_Error_Permission, function () {
          _this._router.navigate(['/home'])
        });
      }
    } else {
      this.SessionExpire();
    }
  }

  async GetCompanyUSEIO(ObjData) {
    var Chk = false;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sRequestID', ObjData.sRequestID)
    };
    Chk = await this._http.get<any>(this.SiteName + "api/_System/CheckCompanyUseIO", httpOptions).toPromise();
    return Chk;
  }

  async GetCompanyUSEGL(ObjData) {
    var Chk = false;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sRequestID', ObjData.sRequestID)
    };
    Chk = await this._http.get<any>(this.SiteName + "api/_System/CheckCompanyUseGL", httpOptions).toPromise();
    return Chk;
  }

  async CheckPermissionMeun(nMenuID) {
    var Chk = false;
    const httpOptions_ChkPermission = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }), params: new HttpParams()
        .set('nMenuID', nMenuID)
    };
    Chk = await this._http.get<any>(this.SiteName + "api/_System/CheckPermissionMeun", httpOptions_ChkPermission).toPromise();
    return Chk;
  }


  //#region Session Function
  TimeoutCounting: string = "00:00";
  seconds = 0;
  SessionInterval: any; // Moved it out.
  PopupInterval: any; // Moved it out.

  CreateTimeInterval() {
    let ua = this.GetUserStorage();
    if (ua) {
      var CurrentDate = new Date();
      var UserExpire = Date.parse(ua.ExpireTime);
      var Diff = (UserExpire - CurrentDate.getTime()) / 1000;
      this.seconds = Math.ceil(Diff) - 20; //  ตั้งใจตัดออก 20 วิกัน Seesion หน้าบ้านไปต่อไม่ทัน
      this.SessionInterval = setInterval(() => this.SessionTimeout(), 1000);

      //let sTextResult = "";
      //sTextResult += "CurrentDate : " + CurrentDate.toString() + "\n";
      //sTextResult += "UserExpire : " + ua.ExpireTime + "\n";
      //sTextResult += "CurrentDateGetTime : " + CurrentDate.getTime() + "\n";
      //sTextResult += "UserExpireGetTime : " + UserExpire + "\n";
      //sTextResult += "Diff : " + Diff;
      //console.log(sTextResult);
    }
  }

  CreateTimeInPopupInterval() {
    document.getElementById("PopupTimeCount").innerHTML = "" + this.TimeoutCounting;
  }

  SessionTimeout() {
    var This = this;
    this.seconds--;
    var min = Math.floor(this.seconds / 60);
    var sec = Math.floor(this.seconds - (min * 60));
    this.TimeoutCounting = (min + "").padStart(2, '0') + ":" + (sec + "").padStart(2, '0');
    if (this.TimeoutCounting == "05:30") {
      this.PopupInterval = setInterval(() => this.CreateTimeInPopupInterval(), 1000);
      this._swal.SwAlert.ConfirmSession("Your session is about to expire!", "<span id=\"PopupTimeCount\"></span><br />Click Yes to continue your session.", function () { This.ConnectSession(); }, function () { Swal.close(); });
    }
    else if (this.TimeoutCounting == "00:00") {
      this._router.navigate(["/login"]);
      Swal.close();
    }
  }

  ConnectSession() {
    clearInterval(this.PopupInterval);
    let This = this;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this._http.post("api/SessionTimeOut/ConnectSession", {}, { headers, responseType: 'text' }).subscribe(res => {
      if (res) {

      }
      else {
        const httpOptions_User = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        };
        This._http.get<any>(This.SiteName + "api/_System/GetLoginStorage", httpOptions_User).subscribe(res => {
          if (res) {
            localStorage.removeItem(This.LoginKey);
            sessionStorage.setItem(This.LoginKey, JSON.stringify(res));
            clearInterval(this.SessionInterval);
            this.CreateTimeInterval();
          }
        });
      }
    });
  }

  ClearTimeInterval() {
    clearInterval(this.SessionInterval);
    clearInterval(this.PopupInterval);
    window.clearInterval(this.SessionInterval);
    window.clearInterval(this.PopupInterval);
  }
  //#endregion
}
